import * as TYPES from './capability-actiontypes';

export const initialState = {
  capabilities: [],
  languages: [],
};

const capabilityReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.CAPABILITY_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.CAPABILITY_LOADED_FAILURE:
      newState = { capabilities: initialState.capabilities };
      break;
    case TYPES.SYSTEM_CAPABILITY_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.SUPPORTED_LANGUAGES_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.SUPPORTED_LANGUAGES_LOADED_FAILURE:
      newState = { languages: initialState.languages };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default capabilityReducer;
